import React, { useEffect, useState } from 'react';
import axios from "axios";
import { useParams } from "react-router-dom";
import styled from 'styled-components';

import CircularProgress from '@mui/material/CircularProgress';
import { ThemeProvider } from "@mui/material/styles";
import theme from "../style/theme.js";

import Logo from '../components/Logo.js';
import NavBar from '../components/NavBar.js';
import Footer from '../components/Footer.js';
import Element from '../components/Element.js';

import { apiSearchElements } from '../api.js';
import ElementFormSearch from '../components/ElementFormSearch.js';

const myEnv = process.env
const protocole = myEnv.REACT_APP_SERVERPROTOCOLE
const host = myEnv.REACT_APP_SERVERHOSTNAME
const port = myEnv.REACT_APP_SERVERPORT
const apiTheatra = `${protocole}${host}:${port}`


const Page = styled.div`
position:relative;
min-height:100vh;
padding-bottom:300px;
`
const Title = styled.h2`
margin:0 auto;
`

const PageElementsSearch = () => {
    const {typeElement, nb, index} = useParams()


    const [elements, setElements] = useState(null)
    const [critere, setCritere] = useState(null)
    const [total, setTotal] = useState(0)
    const [loading, setLoading] = useState(true)
    const [erreur, setErreur] = useState(false)

    useEffect(() => {
        apiSearchElements(typeElement, critere, nb, index)
        .then(res => {
            setElements(res.reponse.rows)
            setTotal(res.reponse.count)
            setLoading(false)
        })
        .catch(error => {
            console.log(error)
            setLoading(false)
            setErreur(true)
        })
    }, [typeElement, critere, nb, index])

    const onSubmit = (element) => {

        console.log("Recherche")
        const {critere} = element
        console.log(critere)
        setCritere(critere)
        const headers = {
            'accept': 'application/json',
        }

        axios({
            //method post au lieu de put pour le file upload...
            method: 'post',
            headers: headers,
            url:  `${apiTheatra}/${typeElement}/limit/${nb}/index/${index}`,
            data:  {critere: critere}
        })
        .then((reponse) => {
            if (reponse.status === 200) {
                //alert("Recherche " + typeElement);
                return
            } else {
                Promise.reject()
            }
        })
        .catch((erreur) => {
            alert("Une erreur a eu lieu lors de la modification"
            + " de l'element de type "
            + typeElement
            + " Erreur : "
            + erreur.message)
        })
    }

    return (
        <Page>
            <Logo/>
            <NavBar/>
            <Title>{typeElement} Théatra</Title>
            <ElementFormSearch
                initialValues=''
                onSubmit={onSubmit}
            />
            {! loading  && ! erreur && <h3>{typeElement} (au nombre total de {total})</h3> }
            { elements && elements.map(element => <Element key={element.id} type ={typeElement} elem={element}/>)}
            {loading  && <ThemeProvider  theme={theme}><CircularProgress color="secondary"/><h3>Je charge</h3></ThemeProvider> }
            {erreur  && <h3>J'ai rencontré un problème...</h3> }

            <Footer/>
        </Page>
    )
}
export default PageElementsSearch